import React from "react";
import { TextField } from "@mui/material";

const clampValue = (value, min, max) => {
  if (typeof value !== "number" || Number.isNaN(value)) {
    return min;
  }
  return Math.min(max, Math.max(min, value));
};

export default function NumericInput({
  value,
  onChange,
  min = Number.MIN_SAFE_INTEGER,
  max = Number.MAX_SAFE_INTEGER,
  step = 1,
  inputProps = {},
  ...props
}) {
  const handleChange = (event) => {
    const rawValue = event.target.value;
    if (rawValue === "") {
      onChange(min);
      return;
    }
    const numericValue = Number(rawValue);
    if (Number.isNaN(numericValue)) {
      return;
    }
    onChange(clampValue(numericValue, min, max));
  };

  return (
    <TextField
      {...props}
      type="number"
      value={value}
      onChange={handleChange}
      inputProps={{
        min,
        max,
        step,
        ...inputProps,
      }}
    />
  );
}
